import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import FeedbackModal from './FeedbackModal';

export default function FeedbackBubble() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {/* Floating Feedback Button */}
      <button
        onClick={() => setIsModalOpen(true)}
        className="fixed bottom-6 left-6 z-40 group"
        aria-label="Send feedback"
      >
        <div className="relative">
          {/* Hover effect background */}
          <div className="absolute inset-0 bg-primary-600 rounded-full opacity-0 group-hover:opacity-100 scale-110 transition-all duration-300" />
          
          {/* Main button */}
          <div className="relative bg-primary-500 text-white rounded-full p-4 shadow-lg hover:shadow-xl transform transition-all duration-300 hover:scale-110 group-hover:bg-primary-600">
            <MessageSquare className="w-6 h-6" />
          </div>
          
          {/* Pulse animation for attention */}
          <div className="absolute inset-0 rounded-full bg-primary-400 animate-ping opacity-20" />
        </div>
        
        {/* Tooltip on hover */}
        <div className="absolute left-full ml-3 bottom-1/2 transform translate-y-1/2 opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-300">
          <div className="bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap shadow-lg">
            Send Feedback
            <div className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-1 w-2 h-2 bg-gray-900 rotate-45" />
          </div>
        </div>
      </button>

      {/* Feedback Modal */}
      <FeedbackModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}